// TODO: Remove modal and waitlist
if (!customElements.get("vbb-product-form")) {
  customElements.define(
    "vbb-product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.recipientForm = this.querySelector("recipient-form");
        this.currencySymbol = this.getAttribute("data-currency-symbol");
        this.handleSignupClick = this.handleSignupClick.bind(this);
      }

      setupFormSubmitHandler() {
        this.form = this.querySelector("form");
        this.atcButton = this.querySelector(`#atc-${this.id}`);
        this.cart = document.querySelector("cart-drawer");

        if (this.form) {
          this.form.addEventListener("submit", this.handleAddToCart.bind(this));
        }

        if (this.atcButton) {
          this.atcButton.addEventListener(
            "click",
            this.handleAddToCart.bind(this)
          );
        }
      }

      handleAddToCart(event) {
        event.preventDefault();

        const cartDrawer = document.querySelector("cart-drawer");

        if (!cartDrawer.loading) {
          this.hideError();

          const productFormConfig = fetchConfig("javascript");
          productFormConfig.headers["x-requested-with"] = "XMLHttpRequest";
          delete productFormConfig.headers["Content-Type"];

          const formData = new FormData(this.form);

          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          productFormConfig.body = formData;

          this.cart.open();
          this.cart.setLoading();

          fetch(routes.cart_add_url, productFormConfig)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.showError(response.message);
                this.cart.setNotLoading();
                this.cart.close();
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              } else {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "vbb-product-form",
                });

                this.cart.renderContents(response);
                this.sendAddToCartTrackingEvent();
              }
            })
            .catch((e) => console.error(e))
            .finally(() => {
              if (this.cart && this.cart.classList.contains("is-empty")) {
                this.cart.classList.remove("is-empty");
              }

              this.cart.setNotLoading();
            });
        }
      }

      setupQuantitySelector() {
        const el = this.querySelector(".vbb-product-form__quantity-selector");

        this.quantitySelector = {
          el,
          currentQuantityEl:
            el.querySelector(".vbb-product-form__quantity-selector__current") ??
            null,
          buttons: {
            decrement: el.querySelector("[data-action=decrement]"),
            increment: el.querySelector("[data-action=increment]"),
          },
          currentQuantity: parseInt(this.dataset?.defaultQuantity ?? 1, 10),
          maxQuantity: parseInt(this.dataset?.maxQuantity ?? 0, 10),
        };

        this.quantitySelector.currentQuantityEl.addEventListener(
          "change",
          (e) => this.updateQuantity(e.target.value)
        );
        this.quantitySelector.buttons.decrement.addEventListener(
          "click",
          () => {
            if (this.currentQuantity > 1) {
              this.updateQuantity(this.currentQuantity - 1);
            }
          }
        );

        this.quantitySelector.buttons.increment.addEventListener(
          "click",
          () => {
            if (this.maxQuantity === 0) {
              return this.updateQuantity(this.currentQuantity + 1);
            }

            if (this.currentQuantity + 1 <= this.maxQuantity) {
              this.updateQuantity(this.currentQuantity + 1);
            }
          }
        );
      }

      updateQuantity(newQuantity, firstUpdate = false) {
        this.currentQuantity =
          this.maxQuantity !== 0 && newQuantity > this.maxQuantity
            ? this.maxQuantity
            : newQuantity;

        this.quantitySelector.currentQuantityEl.value = this.currentQuantity;
        this.quantitySelector.currentQuantityEl.setAttribute(
          "aria-label",
          `Quantity is ${this.currentQuantity}`
        );

        if (this.currentQuantity === 1) {
          this.quantitySelector.buttons.decrement.setAttribute(
            "disabled",
            "disabled"
          );
        }

        if (this.currentQuantity > 1) {
          if (
            this.maxQuantity > 0 &&
            this.currentQuantity === this.maxQuantity
          ) {
            this.quantitySelector.buttons.increment.setAttribute(
              "disabled",
              "disabled"
            );
          } else {
            this.quantitySelector.buttons.increment.removeAttribute("disabled");
          }

          this.quantitySelector.buttons.decrement.removeAttribute("disabled");
        }

        if (!firstUpdate) {
          this.updateProductFormInputs();
        }
        if (
          this.activeVariantTemplate.querySelector("#in-stock").innerText ===
          "true"
        ) {
          this.updateButtonText();
        }
      }

      updateButtonText() {
        this.currencySymbol = this.getAttribute("data-currency-symbol");

        let buttonText = "";

        if (this.presaleEnabled) {
          buttonText = "Presale";

          if (!this.inProductCard) {
            buttonText = `${buttonText} - ${
              this.querySelector(
                `#vbb-variant-details-${this.activeVariant}`
              ).content.querySelector("#title").innerText
            }`;
          }

          buttonText = `${buttonText} - ${this.currencySymbol}${(
            this.variantPrice * this.currentQuantity
          ).toFixed(2)}`;
        } else {
          let price = this.variantPrice * this.currentQuantity;

          price = this.checkPairWith(price);
          if (this.hidePrice) {
            buttonText = "ADD TO BAG";
          } else {
            buttonText = `${this.currencySymbol}${price.toFixed(
              2
            )} - ADD TO BAG`;
          }
        }

        this.querySelector(`#atc-${this.id}`).innerText = buttonText;
      }

      checkPairWith(price) {
        const pairWithPriceInput =
          this.querySelector("#pair_with_variant_id")?.checked ?? false;
        const pairWithPrice = this.querySelector("#pair-with-price") ?? null;
        if (pairWithPrice && pairWithPriceInput) {
          price += parseFloat(pairWithPrice.dataset.price);
        }

        return price;
      }

      updateProductFormInputs() {
        this.productFormInputs = this.querySelector(
          `#product-form-inputs-${this.id}`
        );

        if (this.productFormInputs) {
          const newProductFormInputs = document.createElement("div");
          const variantIdInput = document.createElement("input");
          const quantityInput = document.createElement("input");
          const sellingPlanInput = document.createElement("input"); // New selling plan input
          const sellingPlanInputValue = this.querySelector("input[name=selling-plan]:checked");

          variantIdInput.setAttribute("type", "hidden");
          variantIdInput.setAttribute("name", "id");
          variantIdInput.setAttribute("value", this.activeVariant);

          quantityInput.setAttribute("type", "hidden");
          quantityInput.setAttribute("name", "quantity");
          quantityInput.setAttribute("value", this.currentQuantity);

          if(sellingPlanInputValue) {
            sellingPlanInput.setAttribute("type", "hidden");
            sellingPlanInput.setAttribute("name", "selling_plan");
            sellingPlanInput.setAttribute("value", sellingPlanInputValue);
            // Replace `this.activeSellingPlan` with the variable holding the selling plan ID
          }
          newProductFormInputs.appendChild(variantIdInput);
          newProductFormInputs.appendChild(quantityInput);
          newProductFormInputs.appendChild(sellingPlanInput);

          this.productFormInputs.innerHTML = newProductFormInputs.innerHTML;
        }
      }

      setupActiveVariantObserver() {
        this.activeVariantObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "data-active-variant"
            ) {
              this.isWaitlisted =
                mutation.target.dataset.isWaitlisted === "true";
              this.activeVariant = mutation.target.dataset.activeVariant;
              this.variantPrice = mutation.target.dataset.variantPrice;
              if (this.quantitySelector) {
                this.quantitySelector.maxQuantity = parseInt(
                  mutation.target.dataset.maxQuantity,
                  10
                );
                this.updateQuantity(this.currentQuantity, true);
              }

              this.updateProductFormInputs();
              this.updateAvailability();
              // this.stickyBarUpdater(this.activeVariant);
              this.updateButtonText();
            }
          });
        });

        this.activeVariantObserver.observe(this, { attributes: true });
      }

      updateAvailability() {
        const addToCartButton = this.querySelector(`#atc-${this.id}`);

        addToCartButton.setAttribute("disabled", "disabled");
        addToCartButton.innerHTML = document
          .querySelector("#vbb-loading-spinner")
          .content.querySelector("#spinner").innerHTML;

        const req = {
          query: `query getProductByHandle {
          product(handle: "${this.activeProduct}") {
            id
            variants(first: 50) {
              edges {
                node {
                  id
                  sku
                  availableForSale
                  inStock_32832290850: metafield(namespace: "variant", key: "location_32832290850_in_stock") {
                    value
                  }
                  inStock_64607453218: metafield(namespace: "variant", key: "location_64607453218_in_stock") {
                    value
                  }
                  inStock_64705200162: metafield(namespace: "variant", key: "location_64705200162_in_stock") {
                    value
                  }
                }
              }
            }
          }
        }`,
        };

        return fetch(
          "https://victoria-beckham-beauty.myshopify.com/api/2023-04/graphql.json",
          {
            method: "POST",
            headers: {
              "x-shopify-storefront-access-token":
                "a3b1de4f5858396ae2196167d33fab70",
              "content-type": "application/json",
              accept: "application/json",
            },
            body: JSON.stringify(req),
          }
        )
          .then((res) => res.json())
          .then((res) => {
            const variant = res.data.product.variants.edges.find(
              (item) =>
                item.node.id ===
                `gid://shopify/ProductVariant/${this.activeVariant}`
            );
            let location_metafield_key =
              this.activeVariantTemplate.querySelector(
                "#location-id"
              ).innerText;
            this.activeVariantTemplate.querySelector("#in-stock").innerText =
              variant.node[`inStock_${location_metafield_key}`]?.value ??
              variant.node.availableForSale;
          })
          .finally(() => {
            const activeVariantSelectorItem = this.querySelector(
              `.vbb-variant-selector__item[data-variant-id="${this.activeVariant}"]`
            );
            const signUpModal = this.querySelector('sign-up-modal');
            const isInStock = this.activeVariantTemplate.querySelector("#in-stock").innerText === "true";

            if (isInStock) {
              if (this.atcButton) {
                this.atcButton.style.display = "block";
              }
              if (this.hidePrice === false) {
                this.updateButtonText();
              } else {
                if (this.presaleEnabled) {
                  addToCartButton.innerText = "Presale";
                } else {
                  addToCartButton.innerText = "Add to Bag";
                }
              }

              activeVariantSelectorItem.classList.remove(
                "vbb-variant-selector__item--disabled"
              );
              addToCartButton.removeAttribute("disabled");
              if (signUpModal) {
                signUpModal.setVisible(false);
              }
            } else {
              activeVariantSelectorItem.classList.add(
                "vbb-variant-selector__item--disabled"
              );
              if (signUpModal) {
                addToCartButton.style.display = "none";
                const variantId = String(this.activeVariant);
                const trackingInfo = JSON.parse(this.activeVariantTemplate.querySelector("#tracking-info").innerText);
                signUpModal.activeVariantId = variantId;
                if (signUpModal.modalOpenerButton) signUpModal.modalOpenerButton.dataset.variantId = variantId;
                signUpModal.updateModalTitle({ trackingInfo });
                signUpModal.setVisible(true);
              } else {
                addToCartButton.innerText = window.variantStrings.soldOut;
                if (this.atcButton) {
                  this.atcButton.style.display = "block";
                }
              }
            }
          });
      }

      stickyBarUpdater(activeVariant) {
        const stickyBar = this.closest(".vbb-product__sticky");

        if (stickyBar) {
          const details = stickyBar.querySelector(
            ".vbb-variant-selector__container"
          );
          const summary = details.querySelector("summary");

          setTimeout(() => {
            const selectedElement = details.querySelector(
              `.vbb-variant-selector__item[data-variant-id="${activeVariant}"]`
            );
            const newLabel = selectedElement.querySelector("label").innerText;

            // Direct replacement of the swatch to accommodate different types
            const target = summary.querySelector('.vbb-variant-selector__item__content--swatch__image--content');
            const replacement = selectedElement.querySelector('.vbb-variant-selector__item__content--swatch__image--content');

            if (target && replacement) {
                target.replaceWith(replacement.cloneNode(true)); // Clone to avoid removing the original element
            }
            if (newLabel) {
              summary.querySelector(".vbb-product__sticky--selector-title").innerText = newLabel;
            }

            if (stickyBar.classList.contains("active")) {
              details.removeAttribute("open");
            }
          }, 200);
        }
      }

      showError(error) {
        this.errorEl.textContent = error;
      }

      hideError() {
        if (this.errorEl) {
          this.errorEl.textContent = "";
        }
      }

      cleanup() {
        this.activeVariantObserver.disconnect();
      }

      sendAddToCartTrackingEvent() {
        if (window.Shopify && window.Shopify.analytics) {
          const trackingInfo = JSON.parse(
            this.activeVariantTemplate.querySelector("#tracking-info").innerText
          );

          window.Shopify.analytics.publish("custom_product_add_to_cart", {
            event: "add_to_cart",
            ecommerce: {
              currency: trackingInfo.currency,
              value:
                trackingInfo.discount != null
                  ? (trackingInfo.price - trackingInfo.discount) *
                    this.currentQuantity
                  : trackingInfo.price * this.currentQuantity,
              items: [
                {
                  item_id: trackingInfo.item_id,
                  item_name: trackingInfo.item_name,
                  affiliation: "Victoria Beckham Beauty",
                  currency: trackingInfo.currency,
                  ...(trackingInfo.discount != null && {
                    discount: parseFloat(trackingInfo.discount),
                  }),
                  index: 0,
                  item_brand: "Victoria Beckham Beauty",
                  ...(trackingInfo.item_variant != null && {
                    item_variant: trackingInfo.item_variant,
                  }),
                  price: parseFloat(trackingInfo.price),
                  quantity: parseInt(this.currentQuantity),
                },
              ],
            },
          });
        }
      }

      get currentQuantity() {
        return this.quantitySelector?.currentQuantity ?? 1;
      }

      set currentQuantity(value) {
        this.quantitySelector.currentQuantity = parseInt(value, 10);
      }

      get maxQuantity() {
        return parseInt(this.quantitySelector?.maxQuantity ?? 0, 10);
      }

      get presaleEnabled() {
        return (
          this.querySelector(
            `#vbb-variant-details-${this.activeVariant}`
          ).content.querySelector("#presale-enabled").innerText === "true"
        );
      }

      get activeVariantTemplate() {
        return (
          this.querySelector(`#vbb-variant-details-${this.activeVariant}`)
            ?.content ?? null
        );
      }

      initiateSignup(){
        this.signupButton = this.querySelector('.sign-up-button');
        this.signupID = this.signupButton.dataset.signupId;
        this.signupIDMobile = this.signupButton.dataset.signupIdMobile;

        // Wait for Attentive SDK to be ready
        if (this.signupID && this.signupIDMobile) {
          window.attentiveReady.then(() => {
            if (this.signupButton) {
              this.signupButton.disabled = false;
              this.signupButton.addEventListener('click', this.handleSignupClick);
            }
          });
        }
      }

      handleSignupClick() {
        if (!window.__attentive) return;

        if (window.innerWidth >= 760) {
          window.__attentive.trigger("null", "null", "null", `${this.signupID}`);
        } else {
          window.__attentive.trigger("null", "null", "null", `${this.signupIDMobile}`);
        }
      }

      connectedCallback() {
        this.activeProduct = this.dataset.activeProduct;
        this.activeVariant = this.dataset.activeVariant;
        this.variantPrice = this.dataset.variantPrice;
        this.hidePrice = this.dataset.hidePrice === "true";
        this.isWaitlisted = this.dataset.isWaitlisted === "true";
        this.waitlistButton = this.querySelector("modal-opener button");
        this.inProductCard = this.dataset.inProductCard === "true";

        this.errorEl = this.querySelector(".vbb-product-form__error");

        this.setupFormSubmitHandler();
        this.setupActiveVariantObserver();

        if (this.dataset.disableQuantitySelector === "false") {
          this.setupQuantitySelector();
          this.updateQuantity(this.currentQuantity, true);
        }
        this.querySelector("button.card-hover")?.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            this.closest(".card-wrapper").classList.toggle("hover-active");
          }
        );

        this.updateProductFormInputs();


        // Signup button
        this.initiateSignup();
      }

      disconnectedCallback() {
        this.cleanup();
      }
    }
  );
}
